import React, { useEffect} from "react";
import { connect } from "react-redux";
import { Table } from 'antd';
import CrudOption from "components/dropdown/crudoption";
import { handleTableChange } from "../../../../../utils/index";
import { getEmployeeList } from "../../../../../redux/employee/employeeState";
import Badge from "components/badge";
import { EMPLOYMENT_STATUS_COLORS } from "variables/constants";
import ProfileDetails from "./ProfileDetails";
import SearchFilter from "components/search/SearchFilter";
import EmployeeAvatar from "./EmployeeAvatar";
import HeaderComponent from "components/card/HeaderComponent";

const EmployeeDirectory = ({ 
    recordList, 
    pagination, 
    doSearch, 
    filters,
}) => {

    const columns = [
        {
            title: `Employee`,
            dataIndex: 'employee_name',
            key: 'employee_name',
            width: '25%',
            sorter: true,
            render:(_, record) => (
                <EmployeeAvatar
                    record={record}
                />
            ),
           
        },
        {
            title: 'ID',
            dataIndex: 'emp_code',
            key: 'emp_code',
            width: '12%',
            sorter: true,
            render: (emp_code) => (
                <span>{emp_code}</span>
            ),
        },
        {
            title: 'Department',
            dataIndex: 'department_name',
            key: 'department_name',
            width: '15%',
            sorter: true,
            render: (department_name) => (
				<span>{department_name}</span>
			),
        },

        {
            title: `Position`,
            dataIndex: 'job_level_name',
            key: 'job_level_name',
            width: '15%',  
            sorter: true,
            render: (job_level_name) => (
				<span>{job_level_name}</span>
			),
        },

        {
            title: `Status`,
            dataIndex: 'employment_status_name',
            key: 'employment_status_name',
            width: '14%',
            sorter: true,
            render: (employment_status_name) => (
                <Badge color={EMPLOYMENT_STATUS_COLORS[employment_status_name]}>
                    <span>{employment_status_name}</span>
                </Badge>
            )
        },
        {
            title: 'Actions',
            dataIndex: 'emp_id',
            key: 'emp_id',
            width: '14%',
            render:(emp_id, record) => {
                return (
                    <CrudOption 
                        baseRoute="/console/employee-details" 
                        recordId={emp_id} 
                        allowDelete={false}  
                        allowEdit={false}
                        allowView={false}
                        allowDetail={true}
                        detailMode="modal"
                        detailHandler={() => {
                            return (
                                <ProfileDetails
                                    recordId={emp_id}
                                    recordData={{ ...record }} 
                                />
                            );
                        }}
                    />
                );
            }
        }
    ];
    
    useEffect(() => {
        doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

    return (
        <>
            <div className="w-1/2">
                <div className="p-1">
					<SearchFilter 
						placeholder="Search by Employee Id or Name" 
						searchHandler={doSearch} 
						filters={filters} 
						pagination={pagination}
					/>
				</div>
            </div>
            <HeaderComponent
                title="Employee Directory"
            >
                <div className="relative w-full overflow-x-auto">
                    <Table
                        size="small"
                        dataSource={recordList} 
                        columns={columns}
                        rowKey={(record) => record.emp_id}
                        pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
                        onChange={handleTableChange(doSearch, filters)}  
                    />
                </div>
            </HeaderComponent>
        </>
  );
};

const mapStateToProps = (state) => ({
    recordList: state.employee.employeeList?.items,
    pagination: state.employee.employeeList?.pagination,
    filters: state.employee.employeeList?.filters,
    requesting: state.employee.employeeList?.requesting,
    error: state.employee.employeeList?.error,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getEmployeeList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDirectory);